import { BaseExportModal, ExportModalProps } from './ExportModal'
import { HOSPITAL_COLUMNS } from 'components/DataExpansionComponents/Hospitals/hospitalColumnsInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startHospitalsExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function HospitalExportModal(props: ExportModalProps) {
  const hospitalColumnHelper = createExportColumnHelper({
    columns: HOSPITAL_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        hospitalColumnHelper.retrieveColumn('hospital_name'),
        hospitalColumnHelper.retrieveColumn('street_addr'),
        hospitalColumnHelper.retrieveColumn('city'),
        hospitalColumnHelper.retrieveColumn('state'),
        hospitalColumnHelper.retrieveColumn('zip_code'),
        hospitalColumnHelper.retrieveColumn('domain'),
        hospitalColumnHelper.retrieveColumn('website_url'),
      ],
    },
    {
      title: 'Hospital Insights',
      elements: [
        hospitalColumnHelper.retrieveColumn('total_hospital_beds'),
        hospitalColumnHelper.retrieveColumn('total_hospital_days'),
        hospitalColumnHelper.retrieveColumn('cafeteria'),
        hospitalColumnHelper.retrieveColumn('dietary'),
        hospitalColumnHelper.retrieveColumn('dietary_under_contract'),
        hospitalColumnHelper.retrieveColumn('meals_per_day'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Hospitals...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startHospitalsExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Hospitals',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Hospitals Download"
      subTitle="Download up to 10,000 hospitals at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Hospitals"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
